var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-details"},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('BarChart',{attrs:{"chartdata":_vm.chartData,"options":_vm.chartOptions,"height":250}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }